import script from "./AppPolityka.vue?vue&type=script&setup=true&lang=js"
export * from "./AppPolityka.vue?vue&type=script&setup=true&lang=js"

import "./AppPolityka.vue?vue&type=style&index=0&id=c57a9362&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c57a9362"]])

export default __exports__